import React, { useState } from "react";

// iPhone Safari can't go fullscreen from a tap - but a home-screen launch
// can. One-time dismissible hint; never shown when already standalone.
const isIOS = /iPhone|iPad/.test(navigator.userAgent);
const isStandalone =
  (window.navigator as any).standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches ||
  window.matchMedia("(display-mode: fullscreen)").matches;

const HomeScreenHint: React.FC = () => {
  const [show, setShow] = useState(() => {
    if (!isIOS || isStandalone) return false;
    try { return localStorage.getItem("aots_a2hs_hint") !== "1"; } catch { return false; }
  });
  // The "fullscreen" button under the camera feed re-summons this card
  React.useEffect(() => {
    const onShow = () => setShow(true);
    window.addEventListener("showA2HSHint", onShow);
    return () => window.removeEventListener("showA2HSHint", onShow);
  }, []);
  if (!show) return null;
  return (
    <div
      onClick={() => {
        setShow(false);
        try { localStorage.setItem("aots_a2hs_hint", "1"); } catch { /* ok */ }
      }}
      style={{
        position: "fixed", left: 10, right: 10, top: 10, zIndex: 40,   // bottom covered SWITCH MODES (crawler 2026-09-02)
        background: "rgba(11,16,32,0.95)", color: "#fff",
        border: "1px solid rgba(255,255,255,0.25)", borderRadius: 14,
        padding: "10px 14px", fontFamily: "system-ui, sans-serif",
        fontSize: 13, lineHeight: 1.45, textAlign: "center",
      }}
    >
      <b>Play fullscreen:</b> tap Share <span style={{ opacity: 0.7 }}>&#x2191;</span> then
      {" "}<b>Add to Home Screen</b> - the icon launches without browser bars.
      <span style={{ opacity: 0.55 }}> (tap to dismiss)</span>
    </div>
  );
};

export default HomeScreenHint;
